"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BunchOfNumbers = void 0;
// TODO(roman): move to misc?
class BunchOfNumbers {
    values = {};
    inc(name, delta) {
        this.values[name] = delta + (this.values[name] ?? 0);
        return this;
    }
    absorb(other) {
        Object.keys(other.values).forEach(k => {
            this.values[k] = other.values[k] + (this.values[k] ?? 0);
        });
        return this;
    }
    get(name) {
        return this.values[name] ?? 0;
    }
    toString() {
        return ('[' +
            Object.keys(this.values)
                .sort()
                .map(k => `${k}:${this.values[k]}`)
                .join(' ') +
            ']');
    }
    toJSON() {
        return { ...this.values };
    }
}
exports.BunchOfNumbers = BunchOfNumbers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVuY2gtb2YtbnVtYmVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9idW5jaC1vZi1udW1iZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUE2QjtBQUM3QixNQUFhLGNBQWM7SUFDUixNQUFNLEdBQTJCLEVBQUUsQ0FBQTtJQUVwRCxHQUFHLENBQUMsSUFBTyxFQUFFLEtBQWE7UUFDeEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxLQUFLLEdBQUcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBO1FBQ3BELE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELE1BQU0sQ0FBQyxLQUF3QjtRQUM3QixNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDcEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQTtRQUMxRCxDQUFDLENBQUMsQ0FBQTtRQUNGLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELEdBQUcsQ0FBQyxJQUFPO1FBQ1QsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUMvQixDQUFDO0lBRUQsUUFBUTtRQUNOLE9BQU8sQ0FDTCxHQUFHO1lBQ0gsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO2lCQUNyQixJQUFJLEVBQUU7aUJBQ04sR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO2lCQUNsQyxJQUFJLENBQUMsR0FBRyxDQUFDO1lBQ1osR0FBRyxDQUNKLENBQUE7SUFDSCxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sRUFBRSxHQUFHLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQTtJQUMzQixDQUFDO0NBQ0Y7QUFqQ0Qsd0NBaUNDIn0=